import Api from "./api";
import OidcManager from "./oidcManager";
import {CustomerEstimate} from "./customers-estimates";
import {QboExportResult} from "./reports";

export interface QboAccount {
    Id: string;
    Name: string;
}

export interface Qbo {
    loginUrl?: string;
    companyLegalName?: string;
    authorisedInQbo? : boolean;
    incomeAccounts: QboAccount[];
    expenseAccounts: QboAccount[];
    materialIncomeAccount: string;
    materialExpenseAccount: string;
}

export class QboApi extends Api {

    public constructor(oidc: OidcManager, address: string) {
        super(oidc, address)
    }

    load(command: {  }): JQueryPromise<Qbo> {
        return super.get("/api/qbo", command);
    }

    saveAuthInfo(command: { code: string | null, realmId: string | null  }): JQueryPromise<Qbo> {
        return super.post("/api/qbo/auth/save", command);
    }

    save(command: { materialIncomeAccount: string, materialExpenseAccount: string,
        laborIncomeAccount: string, laborExpenseAccount: string,
        equipmentIncomeAccount: string, equipmentExpenseAccount: string,
        totalOnlyIncomeAccount: string, totalOnlyExpenseAccount: string,
        overheadAccount: string, otherMarkupAccount: string,
        profitAccount: string, taxAccount: string,
        useDefaultAccounts: boolean}): JQueryPromise<Qbo> {
        return super.post("/api/qbo", command);
    }

    createCustomer(command: CustomerEstimate & { estimateId: number }): JQueryPromise<QboExportResult> {
        return super.post("/api/qbo/customer", command);
    }
    
    logout(command: {  }): JQueryPromise<Qbo> {
        return super.post("/api/qbo/auth/logout", command);
    }
}


// WEBPACK FOOTER //
// ./ClientApp/services/api/qbo.ts